import { Button } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React from 'react'
import { formatNumber } from '../../../../helper/helper';

export const TableRow = (props) => {
  const { name, identify, phone, onShowUserAmount, createdAt, amount, rewardAmount, lastBuyTicketAt, assignPin, id, status } = props;

  return (
    <tr className='text-center'>
      <td>
        <Button variant={amount === null ? "danger" : "info"} className="m-1" onClick={() => onShowUserAmount(id)}>Xem tài khoản</Button>
        <Button style={{ marginRight: 20 }} variant="success" type="submit" onClick={() => assignPin(id)}>Cấp mã pin</Button>
      </td>
      <td>
        <span>{name || ""}</span><br />
        <span className={`fw-900 text-info`}>{identify || ""}</span>
      </td>
      <td>{phone}</td>
      <td className='text-end fw-bold text-info'>{formatNumber(amount)}</td>
      <td className='text-end fw-bold text-success'>{formatNumber(rewardAmount)}</td>
      <td>
        {moment(lastBuyTicketAt || '').format('DD/MM/YYYY HH:mm:ss')}
      </td>
      <td>
        {moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}
      </td>
      <td>
        <span className={`badge bg-${status === 0 ? 'danger' : 'success'}`}>
          {status === 0 ? 'Ngừng hoạt động' : 'Đang hoạt động'}
        </span>
      </td>
    </tr>
  );
};
